import * as preact from "preact";
import PropTypes from "prop-types";

import classname from "../../foundation/utils/classname";
import IconCross from "../Icons/IconCross";
import IconDotSpinner from "../Icons/IconDotSpinner";
import IconTick from "../Icons/IconTick";

import "./style.css";

const { h } = preact;

function FormField(props) {
    const {
        children,
        class: cssClass,
        label,
        labelWidth,
        successMessage,
        errorMessage,
        tipText,
        pendingText,
        disabled,
        shouldDisplayErrorMessageIcon,
        shouldDisplayTipText,
        isPending
    } = props;
    let message;

    if (errorMessage) {
        message = (
            <div class="formFieldMessageContainer error">
                {shouldDisplayErrorMessageIcon && <IconCross/>}
                <p class="formFieldMessage">{errorMessage}</p>
            </div>
        );
    } else if (isPending) {
        message = (
            <div class="formFieldMessageContainer pending">
                <IconDotSpinner/>
                <p class="formFieldMessage">{pendingText}</p>
            </div>
        );
    } else if (successMessage) {
        message = (
            <div class="formFieldMessageContainer success">
                <IconTick/>
                <p class="formFieldMessage">{successMessage}</p>
            </div>
        );
    }

    const labelStyle = labelWidth ? { width: labelWidth } : {};

    return (
        <div class={classname("formField", cssClass, { disabled, hasMessage: Boolean(successMessage || errorMessage) || isPending })}>
            {label && <div class="formFieldLabel" style={labelStyle}>{label}</div>}
            <div class="formFieldContent">
                {children}
                {message}
                {Boolean(tipText) && shouldDisplayTipText && <div className="formFieldTipText">{tipText}</div>}
            </div>
        </div>
    );
}

FormField.propTypes = {
    class: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node.isRequired,
    successMessage: PropTypes.node,
    errorMessage: PropTypes.node,
    tipText: PropTypes.node,
    pendingText: PropTypes.string,
    disabled: PropTypes.bool,
    shouldDisplayErrorMessageIcon: PropTypes.bool,
    shouldDisplayTipText: PropTypes.bool,
    isPending: PropTypes.bool
};

export default FormField;
